"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleSeperator = void 0;
var theme_ui_1 = require("theme-ui");
var index_1 = require("../../../index");
var beforeAndAfterSx = {
    position: "absolute",
    top: "50%",
    overflow: "hidden",
    width: "100vw",
    height: "2px",
    content: "''",
    backgroundColor: index_1.theme.colors.grey900,
    transform: "translateY(-50%)",
};
function TitleSeperator(_a) {
    var children = _a.children;
    return (theme_ui_1.jsx(index_1.Box, { sx: {
            textAlign: "center",
            zIndex: "1",
            overflow: "hidden",
        } },
        theme_ui_1.jsx(index_1.Box, { sx: {
                display: "inline-block",
                position: "relative",
                paddingX: children ? 2 : 0,
                "::before": __assign({ right: "100%" }, beforeAndAfterSx),
                "::after": __assign({ left: "100%" }, beforeAndAfterSx),
            } }, children)));
}
exports.TitleSeperator = TitleSeperator;
